<div class="rubber_stamp" [ngClass]="{'rubber_stamp_medium': stampSize=='medium', 'rubber_stamp_small': stampSize=='small'}">
  <div class='rubber_stamp_title'>{{'TXT_COURSE_IS_FULL' | translate}}</div>
  <div *ngIf="allowBooking" class='rubber_stamp_sub_title'>{{'TXT_COURSE_IS_FULL_SUB_TITLE' | translate}}</div>
</div>
